import type { FullBlockTableFragment } from '@dreamstack/investors-graphql'
import includes from 'lodash/includes'
import type { FunctionComponent } from 'react'
import { TableDefault } from './TableDefault'
import { TableFinanceCalendar } from './TableFinanceCalendar'
import { TableGreyWhiteAlternating } from './TableGreyWhiteAlternating'

// Keys and possibleVariants must match contentful variant
const possibleVariants = ['Default', 'FinanceCalendar', 'GreyWhiteAlternating']

export type TableProps = {
  title: string
  variant: string
  table: JSX.Element
}

const VariantMapping: Record<
  string,
  FunctionComponent<React.PropsWithChildren<{ block: FullBlockTableFragment }>>
> = {
  Default: TableDefault,
  FinanceCalendar: TableFinanceCalendar,
  GreyWhiteAlternating: TableGreyWhiteAlternating,
}

export const Table: FunctionComponent<React.PropsWithChildren<{ block: FullBlockTableFragment }>> = ({
  block,
}) => {
  const variant = block.variant
  const Component =
    !!variant && includes(possibleVariants, variant)
      ? VariantMapping[variant]
      : VariantMapping['Default']

  return <Component block={block} />
}
